/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import _head from 'lodash/head';
import _filter from 'lodash/filter';
import _includes from 'lodash/includes';

export function findAttachments(attachments, { __typename, label, tag, kind }) {
  let candidates = attachments;
  if (__typename) candidates = _filter(candidates, { __typename });
  if (label) candidates = _filter(candidates, { label });
  if (tag) candidates = _filter(candidates, (a) => _includes(a.tags, tag));
  if (kind) candidates = _filter(candidates, (c) => !c.kind || c.kind === kind);
  return candidates.length > 0 ? candidates : null;
}

/**
 * Find an attachment given a search criteria
 *
 * @param  {String} type  Filter by type. Supported types are 'download',
 * 'sketchfab', 'preview'.
 * @param  {String} label Filter by label.
 * @param  {String} tag   Filter by tag presence.
 *
 * @return {BaseAttachment|null}
 */
export function findOneAttachment(
  attachments,
  { __typename, label, tag, kind }
) {
  let candidates = findAttachments(attachments, {
    __typename,
    label,
    tag,
    kind,
  });
  if (!candidates) return null;
  return _head(candidates);
}
